"use strict";

exports.__esModule = true;
exports.default = void 0;

var _tooltip = _interopRequireDefault(require("./tooltip"));

var _tooltip2 = _interopRequireDefault(require("../../directives/tooltip/tooltip"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BTooltip: _tooltip.default
};
var directives = {
  BTooltip: _tooltip2.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components,
    directives: directives
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/tooltip/index.js
// module id = 286
// module chunks = 43